<ngb-progressbar [striped]="true" [animated]="true" class="mb-3 {{class}}" [value]="100" type="dark">{{label}}</ngb-progressbar>
